export default "__VITE_ASSET__lFQVYdWk__"